import type { ConfigType } from './index';

type RegionalApiConfig = {
  readonly API: Readonly<Partial<Pick<ConfigType['API'], 'AI' | 'GRAPHQL_BFF' | 'FILES' | 'ACCOUNTS' | 'USERS'>>>;
};

// EU apps use the regional gateway for browser calls and cluster-local origins
// for server-only FILES/ACCOUNTS/USERS clients. Verify required BFF operations
// before onboarding another app.
// AUTH and KEYCLOAK continue to come from the base config in both environments.
export const europeConfig = {
  prod: {
    API: {
      AI: 'https://kong.prod.eu.newfront.com',
      GRAPHQL_BFF: 'https://kong.prod.eu.newfront.com/api/bff/graphql',
      FILES: 'http://api-files:3000',
      ACCOUNTS: 'http://api-account:3000',
      USERS: 'http://api-users:3000',
    },
  },
  stage: {
    API: {
      AI: 'https://kong.stage.eu.newfront-development.com',
      GRAPHQL_BFF: 'https://kong.stage.eu.newfront-development.com/api/bff/graphql',
    },
  },
} as const satisfies Record<'prod' | 'stage', RegionalApiConfig>;
